<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">产品更新</div>
    <div class="right-content">
      <el-form ref="productForm" label-width="160px" :model="productForm" :rules="rules" class="demo-form-inline">
        <el-form-item label="消息名称：" prop="title">
          <el-input type="text" placeholder="请输入消息名称" v-model="productForm.title" maxlength="20" show-word-limit style="width:400px !important;" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="消息内容：" prop="context">
          <el-input type="textarea" placeholder="请输入消息内容" :rows="3" v-model="productForm.context" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="选择类型：" prop="relationId">
          <div style="display: flex;">
            <el-select v-model="productForm.prodType" placeholder="请选择类型" disabled>
              <!-- <el-option label="类" value="CATEGORY"></el-option> -->
              <el-option label="产品" value="SPU"></el-option>
              <!-- <el-option label="sku" value="SKU"></el-option> -->
            </el-select>
            <el-select style="width: 350px;margin-left: 20px;" clearable v-model="productForm.prodName" :filter-method="filterMethod" filterable placeholder="请输入产品名称关键词搜索" @change="handleChange">
              <el-option v-for="item in tableDataList" :key="item.id" :label="item.name" :value="item" :value-key="item.id"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="离线消息保留：" prop="relationId">
          <el-select v-model="productForm.msgDay" placeholder="请选择" clearable>
            <el-option label="1天" :value="1"></el-option>
            <el-option label="3天" :value="3"></el-option>
            <el-option label="5天" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save" round style="float:right;margin-right:200px;">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { getRelatesInfo, getBannerInfoById } from '@/api/pms'
import { sendUpProductMsg, editUpProductMsg } from '@/api/crm'
import { resolve } from 'path'
export default {
  name: 'productUpdate-detail',
  data () {
    return {
      productForm: {
        prodType: 'SPU',
        prodId: '',
        prodName: '',
        imageUrl: '',
        title: '',
        context: '',
        msgDay: 0,
        type: 2
      },
      tableDataList: []
    }
  },
  async created () {
    console.log('this.$route.query.detail', this.$route.query.detail)
    if (this.$route.query.detail) {
      this.productForm = JSON.parse(this.$route.query.detail)
      this.productForm.type = 2
    }
    this.productForm.prodType = 'SPU'
    console.log('productForm', this.productForm.prodType)
  },
  methods: {
    // 搜索产品
    filterMethod (val) {
      console.log('搜索产品', val)
      if (val.trim()) {
        let param = {
          name: val,
          storeId: process.env.NODE_ENV === 'production' ? 191803 : 190086,
          type: this.productForm.prodType,
          isZeroPurchase: false
        }
        getRelatesInfo(param).then(res => {
          if (res.data.success) {
            this.tableDataList = res.data.data
          }
        })
      }
    },
    // 选择产品
    handleChange (val) {
      this.productForm.prodId = val.id
      this.productForm.prodName = val.name
      this.productForm.imageUrl = val.url
    },
    async getBannerDetail (bannerId) {
      await getBannerInfoById(bannerId).then(res => {
        if (res.data.success) {
          this.productForm = res.data.data
          this.productForm.bannerUrl = res.data.data.bannerUrl ? [{ url: res.data.data.bannerUrl }] : []
          this.productForm.detailsUrl = res.data.data.detailsUrl.split(',').map(a => {
            return {
              url: a
            }
          })
          console.log(' this.productForm.', this.productForm)
        }
      })
    },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    removeAppImage (val, type) {
      console.log('removeAppImage', val)
      if (type == 'ban') {
        this.productForm.bannerUrl = []
      } else if (type == 'banDetail') {
        // this.productForm.bannerUrl = []
        this.productForm.detailsUrl = this.productForm.detailsUrl.filter(a => a.uid !== val.uid)
        console.log('productForm.detailsUrl', this.productForm.detailsUrl)
      }
      // this.productForm.bannerUrl = ''
    },
    showAppImagePreview (type) {
      this.showImgPreview = true
      this.previewImage = this.productForm.bannerUrl
    },
    save () {
      if (!this.productForm.title) {
        this.$message.error('消息名称不能为空')
        return
      }
      if (!this.productForm.prodName) {
        this.$message.error('请输入产品关键词')
        return
      }
      if (!this.productForm.context) {
        this.$message.error('请填写消息内容')
        return
      }
      if (!this.productForm.msgDay) {
        this.$message.error('请选择消息保留天数')
        return
      }
      if (!this.productForm.id) {
        sendUpProductMsg(this.productForm).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success'
            })
            this.$router.go(-1)
          }
        }
        )
      } else {
        editUpProductMsg(this.productForm).then(res => {
          if (res.data.success) {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

.el-textarea {
  width: 300px !important;
}

/deep/ .el-input {
  width: 100% !important;
}

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
